import { BufferImageSource, Texture } from "pixi.js";

/** White-hot core and a soft red edge are baked once, not filtered per beam. */
export function laserTexture(shape: "channel" | "muzzle"): Texture {
  const width = shape === "channel" ? 64 : 32,
    height = 32;
  const pixels = new Uint8Array(width * height * 4);
  for (let y = 0; y < height; y++)
    for (let x = 0; x < width; x++) {
      const across = Math.abs(y - (height - 1) / 2) / ((height - 1) / 2);
      const distance =
        shape === "channel"
          ? across
          : Math.hypot(across, (x - (width - 1) / 2) / ((width - 1) / 2));
      const core = Math.max(0, 1 - distance / 0.22);
      const halo = Math.max(0, 1 - distance) ** 2;
      const edge =
        shape === "channel" ? Math.min(1, x / 2, (width - 1 - x) / 2) : 1;
      const index = (y * width + x) * 4;
      pixels[index] = 255;
      pixels[index + 1] = Math.round(56 + core * 194);
      pixels[index + 2] = Math.round(34 + core * 200);
      pixels[index + 3] = Math.round(Math.max(core, halo * 0.7) * edge * 255);
    }
  return new Texture({
    source: new BufferImageSource({
      resource: pixels,
      width,
      height,
      format: "rgba8unorm",
      alphaMode: "no-premultiply-alpha",
      scaleMode: "linear",
    }),
  });
}
